import va from "@vercel/analytics";

const LOG_TAG = "❌ ErrorTrace";
const DEBUG = false;

export default function ErrorTrace({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const { message, name, stack } = error;
  if (DEBUG) console.debug(LOG_TAG, { message, name });
  va.track('Client-side error', { name, message });
  return (
    <div className="p-8">
      <h2 className="text-4xl mb-4">Error: {message}</h2>
      <button type="button" className="btn btn-outline" onClick={() => reset()}>
        Try again
      </button>
      <h3 className="text-2xl mt-12">Stack Trace</h3>
      <div className="whitespace-break-spaces">{stack}</div>
    </div>
  );
}
